
import { Injectable } from '@angular/core';
import { UrlConstantes } from '../utilerias/constantes/urlconstantes';
import { Proyecto } from '../shared/model/gestion-proyectos/proyecto';
import { Base } from '../shared/model/core/base.model';
import { HttpClient, HttpEventType } from '@angular/common/http';
import { ConsultaList } from '../shared/model/core/ConsultaList.model';
import { GrupoYears } from './modelos/modelo-grupo-years.model';
import { map } from 'rxjs/operators';
import { EvidenciaOportunidad } from '../shared/model/gestion-proyectos/evidenciasOportunidad';
import { comentariosOportunidad } from './modelos/comentariosOportunidad.model';
import { environment } from 'src/environments/environment';
import { Observable } from 'rxjs';
import { TipoOportunidad } from '../shared/model/gestion-proyectos/tipoOportunidad.model';

const API_URL = environment.apiUrl;
@Injectable({
  providedIn: 'root'
})
export class OperativoService {
  constructor(private httpClient: HttpClient) { }
  
  /**
   * Llamado de servicio para guardado de un nuevo proyecto
   * @param projectObject
   * @returns Retorna el objeto base con el codigo de error correspondiente a la operacion.
   */
  saveProyect(projectObject: Proyecto) {
    return this.httpClient.post<Base>(UrlConstantes.GUARDAR_OPORTUNIDAD, projectObject);
  }
  public uploadFiles(data: FormData) {
    return this.httpClient.post(UrlConstantes.FILE_SAVE_OPORTUNIDAD, data, { reportProgress: true,  observe: 'events'})
      .pipe( map(event => {
        switch (event.type) {
          case HttpEventType.UploadProgress:
            const progress = Math.round((100 * event.loaded) / event.total);
            return { status: 'progress', message: progress };
 
          case HttpEventType.Response:
            return event.body;
          default:
            return `Unhandled event: ${event.type}`;
        }
      }));
   }
  getProjectsWithPaginationMarketing( request: ConsultaList<Proyecto>) {
    return this.httpClient.post<any>(UrlConstantes.CONSULTAR_OPORTUNIDAD_MARKETING, request);
  }
  getProjectsWithPaginationODP( request: ConsultaList<Proyecto>) {
    return this.httpClient.post<any>(UrlConstantes.CONSULTAR_OPORTUNIDAD_ODP, request);
  }
  getProjectsWithPaginationDeveloper( request: ConsultaList<Proyecto>) {
    return this.httpClient.post<any>(UrlConstantes.CONSULTAR_OPORTUNIDAD_DESARROLLADOR, request);
  }
  validarOportunidad(oportunidad: Proyecto){
    return this.httpClient.post<Base>(UrlConstantes.CONSULTAR_OPORTUNIDA_REPETIVAS,oportunidad);

  }

  /**
   * Llamado de servicios para el seguimiento de Oportunidad Marketing, ODP y Desarrolladores URLS
   */

  muestraEvidencia(DatosForm: any) {
    return this.httpClient.post<EvidenciaOportunidad>(UrlConstantes.mostrarEvidenciaSeguimiento, DatosForm);
  }

  consultarComentarioOportunidad(idGit: number){
    return this.httpClient.post<comentariosOportunidad[]>(UrlConstantes.CONSULTAR_COMENTARIOS, idGit);
  }
  guardarComentarioOportunidad(comentariodata: comentariosOportunidad) {
   return this.httpClient.post<Base>(UrlConstantes.GUARDAR_COMENTARIO_OPORTUNIDAD, comentariodata);
  }
  
  public guardarComentarioOportunidadArchivo(data: FormData) {
    return this.httpClient
      .post<Base>(UrlConstantes.GUARDAR_COMENTARIO_ARCHIVO_OPORTUNIDAD, data, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => {
          return this.callBackUploadFile(event);
        })
      );
  }

  public guardarArchivoGit(data: FormData) {
    return this.httpClient
      .post(UrlConstantes.GUARDAR_ARCHIVO_GIT_OPORTUNIDAD, data, {
        reportProgress: true,
        observe: "events",
      })
      .pipe(
        map((event) => {
          return this.callBackUploadFile(event);
        })
      );
  }

  private callBackUploadFile(event) {
    switch (event.type) {
      case HttpEventType.UploadProgress:
        const progress = Math.round((100 * event.loaded) / event.total);
        return { status: "progress", message: progress };

      case HttpEventType.Response:
        return { status: "ok", body: event.body };
      default:
        return `Unhandled event: ${event.type}`;
    }
  }

  enviarOportunidad(datos: Proyecto) {
  return this.httpClient.post<Base>(UrlConstantes.ENVIAR_OPORTUNIDAD_SEGUIMIENTO, datos);
  }

   guardarOportunidadSeguimiento(datos: Proyecto){
    return this.httpClient.post<Base>(UrlConstantes.GUARDAR_OPORTUNIDAD_SEGUIMIENTO, datos);                                                   
   }
   
  //  guardarOportunidadSeguimientoDesarrollo(datos: Proyecto){
  //   return this.httpClient.post<Base>(UrlConstantes.GUARDAR_OPORTUNIDAD_SEGUIMIENTO_Desarrollo, datos);                                                   
  //  }

   rechazarSolicutd(datos: Proyecto){
    return this.httpClient.post<Base>(UrlConstantes.RECHAZAR_OPORTUNIDAD_SEGUIMIENTO_REVISION,datos);
   }

  /**
   * Empieza todo el motodo para consultar o agregar grupos 
   */
  getGroupsWithPagination( request: ConsultaList<GrupoYears>) { //
    return this.httpClient.post<any>(UrlConstantes.CONSULTAR_GRUPOS, request);
  }
  getGroupsGitlabHybridWithPagination( request: ConsultaList<GrupoYears>) {
    return this.httpClient.post<any>(UrlConstantes.CONSULTAR_GRUPOS_GITLAB_HIBRIDO, request);
  }
  ValidarRegistrosRepetidos(datos: GrupoYears){
    return this.httpClient.post<Base>(UrlConstantes.CONSULTAR_GRUPOS_REPETIVOS, datos );
  } 
  saveGrupoYears(datos: GrupoYears){
    return this.httpClient.post<Base>(UrlConstantes.GUARDARGRUPOYEARS, datos);
  }
  
  consultarGrupos(datos: GrupoYears){
    return this.httpClient.post<GrupoYears[]>(UrlConstantes.LISTA_GRUPOS, datos);
  }

  consultaTipoOportunidades(){
    return this.httpClient.get<ConsultaList<TipoOportunidad>>(UrlConstantes.CONSULTAR_TIPO_OPORTUNIDADES);
  }

  consultaGruposIdPadre(idPadre: number): Observable<any[]> {
    return this.httpClient.post<any[]>(
      API_URL + 'controller/consultaGruposIdPadre.do',
      idPadre
    );
  }
}
